@if (!hideButtons()){
<button class="action-btn" [ariaLabel]="reduceLabel()" [disabled]="disabledDecrement()" (click)="decrement()">
    <mat-icon
        svgIcon="ico_minus"
        trackClick
        [trackClick]="{ fieldName: 'subtractitems', isFormInteraction: true }"
    ></mat-icon>
</button>
}
<span class="counter-value">{{ modifiedCount() }}</span>
@if (!hideButtons()){
<button class="action-btn" [ariaLabel]="increaseLabel()" [disabled]="disabledIncrement()" (click)="increment()">
    <mat-icon
        svgIcon="ico_plus"
        trackClick
        [trackClick]="{ fieldName: 'additems', isFormInteraction: true }"
    ></mat-icon>
</button>
}
